import React from "react";
import classNames from "classnames";
import { CHECK, REFRESH } from "icons";
import { Button } from "ui/index";
import { Checkbox } from "ui/components/checkbox";
import { Badge } from "ui/components/badge";
import { Icon } from "components";

export default function InboxToolbar({
  status,
  allSelected,
  someSelected,
  toggleSelectAll,
  pageIdsLength = 0,
  selectedCount = 0,
  isRefreshing = false,
  onRefresh,
  onClearSelected,
  onDeselectAll,
  isMutating = false,
}) {
  return (
    <div className="flex items-center justify-between px-4 py-2 bg-background border-b min-h-12">
      <div className="flex items-center gap-2">
        {status === "inbox" && (
          <div
            className="flex items-center justify-center p-1"
            title={allSelected ? "Deselect all" : "Select all"}
          >
            <Checkbox
              checked={
                allSelected ? true : someSelected ? "indeterminate" : false
              }
              onCheckedChange={toggleSelectAll}
              disabled={pageIdsLength === 0}
              aria-label="Select all"
            />
          </div>
        )}

        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 text-muted-foreground hover:text-foreground cursor-pointer"
          onClick={onRefresh}
          title="Refresh notifications"
          disabled={isRefreshing}
        >
          <Icon
            icon={REFRESH}
            className={classNames("size-4", isRefreshing && "animate-spin")}
          />
        </Button>

        {status === "inbox" && selectedCount > 0 ? (
          <div className="flex items-center gap-2.5">
            <Badge
              variant="secondary"
              className="font-semibold text-xs px-2.5 py-0.5"
            >
              {selectedCount} selected
            </Badge>

            <Button
              variant="outline"
              size="sm"
              className="h-8 gap-1.5 text-xs font-medium border shadow-xs transition-colors"
              disabled={isMutating}
              onClick={onClearSelected}
            >
              <Icon icon={CHECK} className="size-3.5" />
              Clear ({selectedCount})
            </Button>

            <Button
              variant="ghost"
              size="sm"
              className="h-8 text-xs text-muted-foreground hover:text-foreground"
              onClick={onDeselectAll}
            >
              Deselect
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
